export enum AttributeTypes {
    CarpetSpec = 1,
    CarpetColor = 2,
    HeelPad = 3,
    Trim = 4,
    TrimColor = 5,
}

export enum OrderFilter {
    All = 2,
    Ordered = 1,
    Pending = 0,
}

export enum UnknownOrderEntity {
    Product = 1,
    Pattern = 2,
}
